import React from "react";
import PropTypes from "prop-types";
import { Modal } from "antd";

export default class DialogAddArchitectAlias extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
    }
  }

  render() {
    return (
      <Modal
        visible={this.props.visible}
        onCancel={this.props.onClose}
      >

      </Modal>
    )
  }
}

DialogAddArchitectAlias.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

DialogAddArchitectAlias.defaultProps = {
  // visible: false,
}